export const CONSOLIDATED_SHIPPING_COPY = 'Bundled shipping'

// Breakpoints
export const BREAKPOINT_MOBILE = 525
export const BREAKPOINT_TABLET = 768
export const BREAKPOINT_LARGE_TABLET = 1024
export const BREAKPOINT_DESKTOP = 1224
export const BREAKPOINT_LARGE_DESKTOP = 1440
